// ================= IMPORTS (ALL AT TOP) =================
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext";

// PAGES
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import Compiler from "./pages/Compiler";
import ComingSoon from "./pages/ComingSoon";
import Logs from "./pages/Logs";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import VerifyOtp from "./pages/VerifyOtp";
import Tests from "./pages/Tests";
import TestPreCheck from "./pages/TestPreCheck";
import TestAttempt from "./pages/TestAttempt";
import Lab from "./pages/lab";
import Courses from "./pages/Courses";
import Profile from "./pages/Profile";

// ADMIN
import AdminDashboard from "./pages/Admin/AdminDashboard";
import AdminQuestions from "./pages/Admin/AdminQuestions";
import AdminLogin from "./pages/AdminLogin";

// ================= ROUTE GUARDS =================
function RequireUser({ children }) {
  const { user, loading } = useAuth();

  // ⏳ WAIT until auth state ready
  if (loading) return null;

  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "user") return <Navigate to="/admin-login" replace />;

  return children;
}

function RequireAdmin({ children }) {
  const { user, loading } = useAuth();

  // ⏳ WAIT until auth state ready
  if (loading) return null;

  if (!user) return <Navigate to="/admin-login" replace />;
  if (user.role !== "admin") return <Navigate to="/" replace />;

  return children;
}

// ================= APP =================
function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* AUTH */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/verify-otp" element={<VerifyOtp />} />
        <Route path="/admin-login" element={<AdminLogin />} />

        {/* USER */}
        <Route
          path="/"
          element={
            <RequireUser>
              <Home />
            </RequireUser>
          }
        />

        <Route
          path="/home"
          element={
            <RequireUser>
              <Home />
            </RequireUser>
          }
        />

        <Route
          path="/dashboard"
          element={
            <RequireUser>
              <Dashboard />
            </RequireUser>
          }
        />

        <Route
          path="/profile"
          element={
            <RequireUser>
              <Profile />
            </RequireUser>
          }
        />

        <Route
          path="/compiler"
          element={
            <RequireUser>
              <Compiler />
            </RequireUser>
          }
        />

        <Route
          path="/logs"
          element={
            <RequireUser>
              <Logs />
            </RequireUser>
          }
        />

        <Route
          path="/courses"
          element={
            <RequireUser>
              <Courses />
            </RequireUser>
          }
        />

        <Route
          path="/tests"
          element={
            <RequireUser>
              <Tests />
            </RequireUser>
          }
        />

        <Route
          path="/tests/:id/precheck"
          element={
            <RequireUser>
              <TestPreCheck />
            </RequireUser>
          }
        />

        <Route
          path="/tests/:id/attempt"
          element={
            <RequireUser>
              <TestAttempt />
            </RequireUser>
          }
        />

        <Route
          path="/labs"
          element={
            <RequireUser>
              <Lab />
            </RequireUser>
          }
        />

        <Route
          path="/leaderboard"
          element={
            <RequireUser>
              <ComingSoon title="Leaderboard" />
            </RequireUser>
          }
        />

        {/* ADMIN */}
        <Route
          path="/admin"
          element={
            <RequireAdmin>
              <AdminDashboard />
            </RequireAdmin>
          }
        />

        <Route
          path="/admin/tests/:id"
          element={
            <RequireAdmin>
              <AdminQuestions />
            </RequireAdmin>
          }
        />

        {/* FALLBACK */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
